import Button from "@/components/buttons/Button";

export type SubmitButtonProps = {
    loading?: boolean
    hasPrev: boolean
    prevLabel?: string
    nextLabel?: string
    onPrev?: () => void
}

const SubmitButton = (props: SubmitButtonProps) => {

    const handlePrev = () => {
        props.onPrev && props.onPrev();
    }

    return (
        <div className="col-span-2 flex justify-end gap-4">
            {
                props.hasPrev && (
                    <Button 
                        type="button" 
                        intent="default" 
                        size="md" 
                        className="min-w-32"
                        onClick={handlePrev}
                    >
                        { props.prevLabel ?? "Back"}
                    </Button>
                )
            }
            <Button 
                type="submit" 
                intent="primary" 
                size="md" 
                className="min-w-32"
                loading={props.loading}
            >
                { props.nextLabel ?? "Continue"}
            </Button>
        </div>
    )
}

export default SubmitButton